var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v("异步加载文件")]),_c('d2-markdown',{attrs:{"url":"markdown/demo.md"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }